export default __webpack_public_path__ + "static/media/video-friend.55cc1caa.jpg";